import React from 'react'
import RightSidebarGlobal from '../../Components/RightSidebarGlobal'
import who_we_are from "../../Assets/images/who_we_are.png";
import who_we_are_2 from "../../Assets/images/krisi.png";
import { DOMAIN_NAME } from '../../routes/config';

function WhoWeAre() {
  return (
    <>
    <div class="wrapper">
    <div class="inner_page_Sec">
    <div class="col-sm-12 float-left left_sec searchPageTop">

    <h1>Who We Are?</h1>
    <p><img src={`${who_we_are_2}`} alt="Benfed"/></p>
    <p><strong>The West Bengal State Cooperative Marketing Federation Limited</strong> commonly known as <strong>BENFED</strong> is a state-level 
    apex cooperative marketing Federation established in 1958, under <u><a href="https://wb.gov.in/acts/act_co_opp_cooperative_act.pdf" target="_blank">the West 
    Bengal Cooperative Societies Acts, 1940</a></u>, by the Department of Cooperation, Government of West Bengal. Being the apex body of cooperative marketing 
    societies in West Bengal, social responsibility/welfare and emphasis on delivering just service to the agriculture community of the state are embedded in 
    our approach. <br />
  BENFED ascertains its presence in every step of farming cycle in the state of West Bengal with the primary objective to provide assistance to farming 
  brothers and sisters through the established cooperative channel. It has a diversified presence and vast marketing network comprising of 
  <u> <a href={`${DOMAIN_NAME}contact-us`}>18 branch offices</a></u> and a 
  significant quantity of <u><a href={`${DOMAIN_NAME}ware-house`} >Storage Space</a></u>  &nbsp;
   covering 20 districts out of 23 districts throughout the state of west Bengal. <br/>
  BENFED has four categories of members totaling 321 excluding Class-D members who has no voting rights. Its area of operation throughout the state of 
  West Bengal, member types are drawn below: - </p>
  <p>BENFED&rsquo;S PAN AABAT0010H <br/>
  BENFED&rsquo;S GST 19AABAT0010H2ZY <br/>
  BENFED&rsquo;S TAN CALT02150B </p>

<img src={`${who_we_are}`} alt="Benfed"/>



    </div>
    {/* <div class="col-sm-4 float-left">
    <RightSidebarGlobal/>
    </div> */}

    </div>
    </div>

    </>
  )
}

export default WhoWeAre